<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <!-- Section Colors -->
        <div>
          <label class="label-input mb-4">Section Colors</label>
          <v-row>
            <v-col cols="6">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="text-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['text-color']"
                      @change="handleChangeTextColor"
                    />
                    <v-text-field v-model="fields['text-color']" label="Text Color" />
                    <v-btn @click="handleResetTextColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="6">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="background-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['background-color']"
                      @change="handleChangeBackgroundColor"
                    />
                    <v-text-field v-model="fields['background-color']" label="Background Color" />
                    <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>

        <!-- Button Colors -->
        <div>
          <label class="label-input mb-4">Button Colors</label>
          <v-row>
            <v-col cols="6">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="button-text-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['button-text-color']"
                      @change="handleChangeButtonTextColor"
                    />
                    <v-text-field v-model="fields['button-text-color']" label="Button Text Color" />
                    <v-btn @click="handleResetButtonTextColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="6">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="button-background-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['button-background-color']"
                      @change="handleChangeButtonBackgroundColor"
                    />
                    <v-text-field v-model="fields['button-background-color']" label="Button Background Color" />
                    <v-btn @click="handleResetButtonBackgroundColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>

        <!-- Pagination Colors -->
        <div>
          <label class="label-input mb-4">Pagination Colors</label>
          <v-row>
            <v-col cols="6">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="pagination-active-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['pagination-active-color']"
                      @change="handleChangePaginationActiveColor"
                    />
                    <v-text-field v-model="fields['pagination-active-color']" label="Pagination Active Color" />
                    <v-btn @click="handleResetPaginationActiveColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="6">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="pagination-inactive-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['pagination-inactive-color']"
                      @change="handleChangePaginationInactiveColor"
                    />
                    <v-text-field v-model="fields['pagination-inactive-color']" label="Pagination Inactive Color" />
                    <v-btn @click="handleResetPaginationInactiveColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
        <div>
          <label class="label-input">Content</label>
          <!-- <ckeditor :editor="editor" v-model="fields['content']" :config="editorConfig" /> -->
          <v-checkbox v-model="fields['container-page']" label="Container Page" />
          <div class="mb-7">
            <div class="d-flex justify-space-between align-center">
              <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                <label style="margin-bottom: 0">Banner</label>
              </div>
              <v-btn small text color="primary" @click="handleAddItem">
                <v-icon size="16">mdi-plus</v-icon>
                <span>Add Item</span>
              </v-btn>
            </div>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields['list-item']" :key="i">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Banner {{ i + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveItem(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-5">
                    <UploadImage
                      @callback="obj => handleUploadImage(obj, i)"
                      :image="{ imageSrc: item.image }"
                      :height="`250`"
                      :resize="{ width: 1920, height: 'auto' }"
                      :typeUpload="'image'"
                      @callbackDelete="handleRemoveUpload(i)"
                    />
                  </div>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-checkbox v-model="item.textBanner.showText" label="Show Text" />
                      <ckeditor :editor="editor" v-model="item.textBanner.text" :config="editorConfig" />
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-checkbox v-model="item.overlay.showOverlay" label="Show Overlay" />
                      <!-- <v-text-field v-model="item.overlay.opacity" label="Opacity" /> -->
                      <div class="mb-5">
                        <v-subheader class="pl-0"> Overlay Opacity </v-subheader>
                        <v-slider
                          v-model="item.overlay.opacity"
                          class="align-center"
                          :step="0.1"
                          :max="1"
                          :min="0"
                          hide-details
                          thumb-label="always"
                        >
                        </v-slider>
                      </div>
                    </v-col>

                    <v-col cols="12" md="12">
                      <v-text-field v-model="item.button.text" label="Button Text" />
                      <v-checkbox v-model="item.button.showBtn" label="Show Button" />
                      <v-text-field v-model="item.button.link" label="Button Link" />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
export default {
  name: 'banner-slider-section-editor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        'text-color': '#ffffff',
        'background-color': '',
        'button-text-color': '#ffffff',
        'button-background-color': '#000000',
        'pagination-active-color': '#000000',
        'pagination-inactive-color': '#cccccc',
        'container-page': false,
        topPadding: true,
        bottomPadding: true,
        'list-item': [
          {
            image: '',
            textBanner: {
              text: '',
              showText: false,
            },
            button: {
              text: '',
              showBtn: false,
              link: '',
              background: '',
              color: '',
            },
            overlay: {
              showOverlay: false,
              opacity: 0.2,
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionBannerSlider(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadImage(obj, i) {
      this.fields['list-item'][i].image = obj.imageSrc;
    },
    handleRemoveUpload(i) {
      this.fields['list-item'][i].image = '';
    },
    handleAddItem() {
      this.fields['list-item'].push({
        image: '',
        textBanner: {
          text: '',
          showText: false,
        },
        button: {
          text: '',
          showBtn: false,
          link: '',
          background: '',
          color: '',
        },
        overlay: {
          showOverlay: false,
          opacity: 0.2,
        },
      });
    },
    handleRemoveItem(i) {
      this.fields['list-item'].splice(i, 1);
    },
    handleChangeTextColor(event) {
      this.fields['text-color'] = event.target.value;
    },
    handleChangeBackgroundColor(event) {
      this.fields['background-color'] = event.target.value;
    },
    handleResetTextColor() {
      this.fields['text-color'] = '#ffffff';
    },
    handleResetBackgroundColor() {
      this.fields['background-color'] = '';
    },
    handleChangeButtonTextColor(event) {
      this.fields['button-text-color'] = event.target.value;
    },
    handleChangeButtonBackgroundColor(event) {
      this.fields['button-background-color'] = event.target.value;
    },
    handleResetButtonTextColor() {
      this.fields['button-text-color'] = '#ffffff';
    },
    handleResetButtonBackgroundColor() {
      this.fields['button-background-color'] = '#000000';
    },
    handleChangePaginationActiveColor(event) {
      this.fields['pagination-active-color'] = event.target.value;
    },
    handleChangePaginationInactiveColor(event) {
      this.fields['pagination-inactive-color'] = event.target.value;
    },
    handleResetPaginationActiveColor() {
      this.fields['pagination-active-color'] = '#000000';
    },
    handleResetPaginationInactiveColor() {
      this.fields['pagination-inactive-color'] = '#cccccc';
    },
  },
};
</script>

<style lang="scss" scoped>
.ck-editor__editable_inline {
  min-height: 300px;
}
.ck-editor__editable {
  min-height: 300px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
